import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppFilter } from "../../../models/app-filter.model";
import { TipoCredencial } from "app/models/credencial/tipo-credencial";
import { AbCredencial } from "app/abstract/full-pages/credencial/credencial.abstract";

@Injectable({ providedIn: 'root' })
export class CredencialService extends AbCredencial {
    prefixo = 'credenciais/';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public salvarAlterarCredencial(entity) {
        return this.save(this.prefixo, entity);
    }

    public saveCredenciaisPessoa(dto: any) {
        return this.post(`${this.prefixo}pessoa`, dto);
    }

    public getCredenciais(filter: AppFilter) {
        return this.get(`${this.prefixo}filter/${filter.encode()}`);
    }

    public getCredenciaisDTO(): Promise<any> {
        return this.get(`${this.prefixo}all/vinculo_pessoa/`).toPromise();
    }

    public getCredenciaisSemVinculo(): Promise<any> {
        return this.get(`${this.prefixo}all/sem_vinculo/`).toPromise();
    }
    public getCredenciaisSemVinculoPorTipo(tipoCredencial: TipoCredencial): Promise<any> {
        return this.get(`${this.prefixo}all/sem_vinculo/${tipoCredencial.id}`).toPromise();
    }

    public getCredenciaisByPessoaId(pessoaId: number): Promise<any> {
        return this.get(`${this.prefixo}pessoa/${pessoaId}`).toPromise();
    }

    public getAllCredenciaisPromise() {
        return this.get(`${this.prefixo}all/dto`).toPromise().catch();
    }

    public deleteCredencial(id: number) {
        return this.delete(this.prefixo, id);
    }

    public getCredencial(id: number) {
        return this.get(this.prefixo, id);
    }

    public sincronizar() {
        return this.get(`${this.prefixo}sincronizar`);
    }

    public saveCredenciaisFacial(usuarioCredencialId: number, base64: string): Observable<any> {
        return this.post(`${this.prefixo}hub/facial/${usuarioCredencialId}`, base64);
    }

    public saveCredencialSenha(usuarioCredencialId: number, senha: string): Observable<any> {
        return this.post(`${this.prefixo}hub/senha/${usuarioCredencialId}`, senha)
    }
}